import { css } from 'styled-components'

export const CATALOG_APPEARANCE = 'catalog'
export const CATALOG_DRAWER_APPEARANCE = 'catalog-drawer'
export const CATALOG_HEADER_APPEARANCE = 'catalog-header'

export const CATALOG_DRAWER_WIDTH = 402
export const CATALOG_SEARCH_WIDTH_DESKTOP = 358

export const catalogLocalVars = css`
  /* Layout */
  --catalog-drawer-width: ${CATALOG_DRAWER_WIDTH}px;
  --catalog-page-padding-x: var(--spacing-42);
  --catalog-page-padding-top: var(--spacing-48);
  --catalog-grid-gap-desktop: var(--spacing-20);
  --catalog-grid-gap-mobile: var(--spacing-12);
  --catalog-card-width-desktop: 324px;
  --catalog-card-width-mobile: 178px;
  --catalog-image-height-desktop: 432px;
  --catalog-image-height-mobile: 227px;

  /* Component dimensions */
  --catalog-filter-btn-height: 38px;
  --catalog-search-height: 40px;
  --catalog-search-width-desktop: ${CATALOG_SEARCH_WIDTH_DESKTOP}px;
  --catalog-filter-tag-height: 30px;
  --catalog-compare-btn-height: 24px;
  --catalog-checkbox-size: 18px;
  --catalog-checkbox-radius: 3px;
  --catalog-pagination-size: 36px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductCatalogueV2/catalogTheme.ts